import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store';
import Geocoder from "@pderas/vue2-geocoder";

Vue.config.productionTip = false
Vue.use(Geocoder, {
    defaultCountryCode: "US",
    defaultLanguage: "en",
    defaultMode: 'address', // or 'lat-lng'
    googleMapsApiKey: "AIzaSyBPwY6FH7hmt6WBy7PwnfoWUmKBdsEm-Ts"
});


new Vue({
            router,
            store,
            vuetify,
            render: h => h(App)
        }).$mount('#app')



